export default "__VITE_ASSET__yXLOO1Ae__"